package one.healthium.today.di

import org.koin.dsl.module

val todayUiPcosModule = module {
    includes(todayModule)
}